var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEmailLabResult(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14.286a.893.893 0 0 0 0-1.786 5.358 5.358 0 1 1 5.357-5.357v1.786a.893.893 0 1 1-1.786 0V7.143a3.57 3.57 0 1 0-3.571 3.571 3.572 3.572 0 0 0 2.045-.652 2.679 2.679 0 0 0 5.098-1.133V7.143a7.143 7.143 0 1 0-7.143 7.143Zm0-5.357a1.786 1.786 0 1 1 0-3.572 1.786 1.786 0 0 1 0 3.572Zm12.152 1.08-2.679-2.063a.893.893 0 0 0-1.09 1.411l1.787 1.357-10.17 7.804-10.143-7.804 1.786-1.357a.9.9 0 1 0-1.116-1.41L.348 10.008a.893.893 0 0 0-.348.705v11.607A2.679 2.679 0 0 0 2.679 25H22.32A2.679 2.679 0 0 0 25 22.321V10.714a.893.893 0 0 0-.348-.705Zm-2.33 13.205H2.678a.893.893 0 0 1-.893-.893V12.5l10.17 7.821a.893.893 0 0 0 1.089 0l10.17-7.821v9.821a.893.893 0 0 1-.894.893Z",
    fill: "#2FAEF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmailLabResult);
export default __webpack_public_path__ + "static/media/icon_email_lab_result.8fb17a4a.svg";
export { ForwardRef as ReactComponent };